//paddle
(function(){
    try{
        Paddle.Setup({
            vendor: 106347,
            eventCallback:function(data){
            }}
        );
        function openCheckout() {
            Paddle.Checkout.open({
                product: $(this).attr('product-id'),
                coupon: $(this).attr('coupon')
            });
        }
        $('a.paddle').click(openCheckout);
        $('a.paddle.unbind').unbind('click');
    }catch(e){
        console.log(e);
    }
})();